import SetData from "@/vuex/SetData";
import Status from "@/vuex/Status";
import Config from "@/vuex/Config";
import CatchFetch from "@/assets/Cache/Fetch";
import Logger from "@/assets/Helper/Logger";

let DAOItemPrice = function () {

    this.getPrice = function (itemnumber) {
        Status.dispatch('setLoading', true).catch((error) => {
            Logger.error(error);
        });

        CatchFetch.cacheFirst(Config.getters.getApiHostWithLocalStr + '/v2/items/prices/sales/' + itemnumber + '/details/')
            .then(json => {
                json.itemnumber = itemnumber;
                SetData.dispatch('setItemPrice', json).catch((error) => {
                    Logger.error(error);
                });
                Status.dispatch('setLoading', false).catch((error) => {
                    Logger.error(error);
                });
            })
            .catch((error) => {
                Status.dispatch('setLoading', false).catch((error) => {
                    Logger.error(error);
                });
                Logger.error(error);
            });
    }
};

export default new DAOItemPrice();